module.exports = __webpack_public_path__ + "img/img1.823a6021.jpg";